import React from "react";
import { Modal, Form, Input, Select, DatePicker, Button } from "antd";
const TimerPopup = ({ open, setOpen, clinicTiming }) => {
  if (!open) return null;
  return (
    <Modal open={open} footer={null} onCancel={() => setOpen(false)}>
      <h1 className="font-primary font-bold text-[1.5rem] bg-primary px-[20px] py-[4vh] text-white">
        Our Clinic Timings
      </h1> 
      <div style={{ padding: "10px" }}>
        {clinicTiming ? (
          Object.entries(clinicTiming)
            .slice(0, 7) // Limits the days to 7
            .map(([day, timings], index) => (
              <div
                key={index}
                style={{
                  marginBottom: "15px",
                  display: "grid",
                  gridTemplateColumns: "100px auto",
                  gap: "10px",
                  alignItems: "start",
                }}
              >
                <strong>{day}:</strong>
                <div>
                  {Array.isArray(timings) && timings.length > 0 ? (
                    timings.map((timing, idx) => (
                      <div key={idx}>
                        {timing.disabled ? (
                          <span style={{ color: "red" }}>Closed</span>
                        ) : (
                          <span>
                            Open: <strong>{timing.opening}</strong> - Close:{" "}
                            <strong>{timing.closing}</strong>
                          </span>
                        )}
                      </div>
                    ))
                  ) : (
                    <span style={{ color: "red" }}>Closed</span>
                  )}
                </div>
              </div>
            ))
        ) : (
          <p>No timings available</p>
        )}
      </div>
    </Modal>
  );
};

export default TimerPopup;
